module.exports = __webpack_public_path__ + "static/img/icon-training1.0eb1789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-training1.png
// module id = CAtg
// module chunks = 21